import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';

import BranchesMap from './BranchesMap';
import {
  getOtherBranchesStart,
  getOtherBranchesSuccess,
} from '../SimilarSearch/redux/actions';
import { selectOtherBranchesData } from '../SimilarSearch/redux/selectors';

export const mapDispatchToProps = dispatch => {
  return {
    getOtherBranchesStart: requestData =>
      dispatch(getOtherBranchesStart(requestData)),
    getOtherBranchesSuccess: requestData =>
      dispatch(getOtherBranchesSuccess(requestData)),
  };
};

export const mapStateToProps = createStructuredSelector({
  otherBranchesData: selectOtherBranchesData,
});

export default connect(mapStateToProps, mapDispatchToProps)(BranchesMap);
